<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-3">
          <div class="list-group custom-list-group">
            <div
              v-for="(item, idx) of activities"
              :key="idx"
              class="list-group-item list-group-item-action"
              :class="{ active: item.name === selectedActivity }"
            >
              <div
                class="d-flex w-100 custom-group"
                @click="selectActivity(item.name)"
              >
                <img
                  :src="item.icon"
                  :class="{
                    'custom-icon-background': item.isSetBackground,
                  }"
                />
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="selectedActivity !== null" class="col-md-5">
          <div class="list-group custom-list-group">
            <div
              v-for="(item, idx) of categories"
              :key="idx"
              class="list-group-item list-group-item-action"
              :class="{ active: item.name === selectedCategory }"
            >
              <div
                class="d-flex w-100 custom-group"
                @click="selectCategory(item)"
              >
                <img :src="item.icon" />
                <span>{{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="selectedCategory !== null" class="col-md-4">
          <div class="row">
            <div class="col-md-12">
              <z-input
                v-model="newCategory.name"
                label=""
                placeholder="Component Name"
                @keyup="saveIt = true"
              />
            </div>
            <div class="col-md-12">
              <div class="input-group">
                <div class="input-group-text custom-goal">
                  <span class="custom-goal-1">goal</span>
                  <span class="custom-goal-2">(optional)</span>
                </div>
                <input
                  v-model="newCategory.goal"
                  type="number"
                  class="form-control custom-goal"
                  min="0"
                  :max="maxGoal"
                  placeholder=""
                  @keyup="saveIt = true"
                  @change="saveIt = true"
                  @blur="checkGoal"
                />
                <div
                  v-if="newCategory.type !== 'numeric'"
                  class="custom-frequency"
                >
                  <span v-if="newCategory.frequency === 1">daily</span>
                  <span v-else-if="newCategory.frequency === 2">weekly</span>
                </div>
                <!-- <select
                  v-if="newCategory.type !== 'numeric'"
                  class="form-select custom-select-disabled"
                  v-model="newCategory.frequency"
                  @change="saveIt = true"
                  :disabled="true"
                >
                  <option
                    v-for="(view, idx) of frequencies"
                    :key="idx"
                    :value="view.value"
                  >
                    {{ view.name }}
                  </option>
                </select> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <z-input
                v-model="newCategory.startDate"
                name="start_date"
                label="Start"
                type="date"
                @change="saveIt = true"
              />
            </div>
            <div class="col-md-6">
              <z-input
                v-model="newCategory.endDate"
                name="end_date"
                label="End"
                type="date"
                @change="saveIt = true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input
                v-model="newCategory.isLeaderboard"
                type="checkbox"
                id="isLeader"
                class="z-checkbox-small"
                @click="saveIt = true"
              />
              <label for="isLeader" class="custom-leaderboard"
                >Leaderboard</label
              >
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              v-show="saveIt"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZDialog from '@/Components/ZElements/Dialog'
export default {
  name: 'component-add',
  components: {
    ZInput,
    ZSelect,
    ZDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      invalidMessage: '',
      saveIt: false,
      selectedActivity: null,
      selectedCategory: null,
      newCategory: {
        name: '',
        goal: null,
        frequency: 1,
        startDate: null,
        endDate: null,
        isLeaderboard: false,
        rule: '',
      },
      frequencies: [
        {
          name: 'daily',
          value: 1,
        },
        {
          name: 'weekly',
          value: 2,
        },
      ],
      maxGoal: 99999,
    }
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapGetters('dashboardComponents', ['dashboardComponents']),
    ...mapGetters('usercardio', ['summary']),
    ...mapGetters('challenges', ['challenge', 'ruletypes']),
    isVisible() {
      return this.show
    },
    title() {
      let _title = 'Add Component'
      return _title
    },
    activities() {
      let _data = []
      if (this.ruletypes) {
        this.ruletypes.forEach((element) => {
          _data.push({
            name: element.name,
            icon: element.icon,
            categories: JSON.parse(JSON.stringify(element.categories)),
            isSetBackground: element.isSetBackground,
          })
        })
      }
      if (this.summary) {
        if (this.summary.organization) {
          if (this.summary.organization.dashboardName) {
            let _categories = []
            if (this.dashboardComponents) {
              this.dashboardComponents.forEach((element) => {
                _categories.push({
                  icon: '/media/challenges/ic_videos_32dp.png',
                  name: `dashboard_${element.name}`,
                  value: element.name,
                  type: 'weekly',
                })
              })
            }
            _data.push({
              name: this.summary.organization.dashboardName,
              icon: '/media/challenges/ic_videos_32dp.png',
              categories: _categories,
              isSetBackground: false,
            })
          }
        }
      }

      console.log('Activities', {
        ruletypes: this.ruletypes,
        activities: _data,
      })
      return _data
    },
    categories() {
      let _data = []
      if (this.selectedActivity) {
        this.activities.forEach((activity) => {
          if (activity.name === this.selectedActivity) {
            if (activity.categories) {
              activity.categories.forEach((category) => {
                _data.push({
                  name: category.name,
                  value: category.value,
                  icon: category.icon,
                  type: category.type,
                })
              })
            }
          }
        })
      }
      console.log('Categories', _data)
      return _data
    },
  },
  methods: {
    reset() {
      this.invalidMessage = ''
      this.selectedActivity = null
      this.selectedCategory = null
      this.newCategory = {
        name: '',
        goal: null,
        frequency: null,
        startDate: null,
        endDate: null,
        isLeaderboard: false,
        rule: '',
        type: null,
      }
      this.newCategory.startDate = moment
        .utc(new Date(this.challenge.start_date))
        .startOf('week')
        .add(1, 'days')
        .format('YYYY-MM-DD')
      this.newCategory.endDate = moment
        .utc(new Date(this.challenge.end_date))
        .startOf('week')
        .add(1, 'days')
        .format('YYYY-MM-DD')
      this.maxGoal = 99999
    },
    selectActivity(name) {
      this.selectedActivity = name
      this.selectedCategory = null
    },
    selectCategory(item) {
      console.log('Selected Category', item)
      this.selectedCategory = item.name
      this.newCategory.rule = item.name
      this.newCategory.name = item.value
      this.newCategory.type = item.type
      this.newCategory.icon = item.icon
      if (item.type === 'weekly') {
        this.newCategory.frequency = 2
      } else if (item.type === 'daily') {
        this.newCategory.frequency = 1
      } else {
        this.newCategory.frequency = null
      }
      this.maxGoal = 99999
      if (item.name === 'NutritionHabits') {
        this.maxGoal = 7
      }
    },
    checkGoal() {
      if (this.newCategory.goal > this.maxGoal) {
        this.newCategory.goal = this.maxGoal
      }
    },
    async performSave() {
      this.$emit('save', this.newCategory)
      this.reset()
    },
    close() {
      this.reset()
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-list-group {
  cursor: pointer;
}
.custom-group {
  position: relative;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
  span {
    padding-top: 3px;
    font-size: 1em;
  }
  small {
    right: 30px;
    position: absolute;
    bottom: 0;
  }
}
.custom-leaderboard {
  margin-left: 5px;
}

.custom-goal {
  max-width: 73.25px;
}
.custom-goal {
  width: 250px;
  padding: 0;
  position: relative;
  min-height: 38px;
}
.custom-goal-1 {
  position: absolute;
  top: -2px;
  left: 5px;
}
.custom-goal-2 {
  position: absolute;
  bottom: 0;
  left: 5px;
  font-size: 0.8em;
}
.custom-frequency {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-icon-background {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 5px;
  border-radius: 5px;
  text-align: center;
}
</style>
